import React from 'react';
import Icon from 'assets/Icon';
import styles from './style/selectToggle.module.css';

const SelectToggle = ({
  active,
  disabled,
  handler,
  label,
  value,
}) => (
  <div
    className={`
      ${styles.selectToggle} 
      ${active ? styles.selectToggle_active : ''} 
      ${disabled ? styles.selectToggle_disabled : ''} 
      ${value ? styles.selectToggle_hasValue : ''}
    `}
    onClick={handler}
    onKeyDown={handler}
    role="button"
    tabIndex={0}
  >
    <div className={styles.selectToggle__label}>
      { label }
    </div>
    <div className={styles.selectToggle__value}>
      { value }
    </div>
    <Icon icon="ExpandMore" fill={disabled ? 'body-100' : 'black'} />
  </div>
);

SelectToggle.defaultProps = {
  active: false,
  disabled: false,
  handler: null,
  label: '',
  value: false,
};

export default SelectToggle;
